import PanelConstants from '@components/central-monitoring/panels/add-panel/panel-constants';
import { PanelModelType, PanelType } from 'types/graphql-global-types';
import { getCm2Panels_OpraQueries_cm2panels_Panel } from '@queries/generated/central-monitoring.generated';
import { PanelFields } from '@queries/generated/fragments.generated';

export type PanelModels = keyof typeof PanelConstants.modelOptions;

// Sometimes the panel check happens using the Study ScoringData config object
// We don't really know what this is, but seems to have this list of constants as its model types
interface SiteScoringPanel {
    panelType: PanelType | null;
    modelParams: {
        type: PanelModels;
    };
}

export const isPanelScatterPlot = (
    panel: PanelFields | getCm2Panels_OpraQueries_cm2panels_Panel | SiteScoringPanel | null | undefined,
) => {
    if (panel == null) return false;

    if (panel.panelType === PanelType.TRI_OP_DATE) return true;

    let isModelScatter: boolean;

    switch (panel?.panelType === PanelType.MODEL && panel?.modelParams?.type) {
        case PanelModelType.FUNNEL:
        case PanelModelType.TRI_OPERATIONAL:
        case PanelModelType.RATE_GROUP:
        case 'FUNNEL':
        case 'RATEGROUP':
        case 'TRIOPERATIONAL':
            isModelScatter = true;
            break;
        default:
            isModelScatter = false;
            break;
    }

    return isModelScatter;
};
